module.exports = __webpack_public_path__ + "static/media/google.eaa7f974.png";